import React from "react";
import { Mic, AudioLines, Video, Lightbulb, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Baby Botox - From £85",
  description: "Precision-focused treatments to soften fine lines while maintaining natural facial expression and movement for a refreshed appearance.",
  icon: Mic
}, {
  title: "Skin Boosters - From £129",
  description: "Deep hydration therapy designed to improve skin quality, elasticity, and overall radiance from within using premium hyaluronic acid.",
  icon: AudioLines
}, {
  title: "Dermal Fillers -From £139",
  description: "Artfully applied hyaluronic acid to restore volume, contour features, and enhance your natural symmetry with clinical excellence.",
  icon: Video
}, {
  title: "Chemical Peels - From £55",
  description: "Medical-grade exfoliation to resurface skin texture, treat pigmentation, and reveal a clearer, more youthful complexion.",
  icon: Lightbulb
}, {
  title: "Microneedling - From - £80",
  description: "Advanced collagen induction therapy to minimize pores, scars, and signs of aging through the body's natural healing process.",
  icon: Users
}];
export default function Services() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="18218" id="aesthetics-services" ref={ref} className={`py-24 bg-background text-foreground transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className={`group ${i === 4 ? "lg:translate-y-12" : ""} transition-transform duration-500`}>
              <Card className="h-full border border-border/40 bg-card/40 backdrop-blur-[12px] shadow-[0_10px_40px_rgba(0,0,0,0.02)] rounded-[2rem] hover:scale-[1.02] hover:bg-secondary/30 transition-all duration-500 ease-in-out">
                <CardHeader className="pb-4">
                  <div className="mb-6">
                    <service.icon className="w-10 h-10 text-ring/70 stroke-[1]" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-serif italic text-3xl font-light tracking-wide text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-sans text-sm leading-relaxed tracking-normal text-muted-foreground/80">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}